import Notice from './Notice'

interface UpgradePromptProps {
  title?: string
  ctaText?: string
  ctaPath?: string
}

const UpgradePrompt = (props: UpgradePromptProps) => {
  const {
    title = "Your plan doesn't support this feature",
    ctaText = 'Upgrade now',
    ctaPath = '/subscription/plans',
  } = props

  return (
    <Notice
      title={title}
      ctaText={ctaText}
      ctaPath={ctaPath}
      type="info"
      layout="horizontal"
      className="qa-upgrade-prompt"
    />
  )
}

export default UpgradePrompt
